// React Query hooks for admin-user CRUD.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from './admin-users.api';

export const ADMIN_USERS_KEY = 'admin-users';

export function useAdminUsers(query: api.AdminUserListQuery) {
  return useQuery({
    queryKey: [ADMIN_USERS_KEY, query],
    queryFn: () => api.listAdminUsers(query),
    placeholderData: (prev) => prev,
  });
}

export function useCreateAdminUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: api.CreateAdminUserInput) => api.createAdminUser(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ADMIN_USERS_KEY] }),
  });
}

export function useUpdateAdminUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: api.UpdateAdminUserInput }) =>
      api.updateAdminUser(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ADMIN_USERS_KEY] }),
  });
}

export function useDeleteAdminUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteAdminUser(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ADMIN_USERS_KEY] }),
  });
}
